// File: e1p/src/utils/logger.js
const logger = {
    log: (...args) => console.log('[E1P LOG]', ...args),
    info: (...args) => console.info('[E1P INFO]', ...args),
    warn: (...args) => console.warn('[E1P WARN]', ...args),
    error: (...args) => console.error('[E1P ERROR]', ...args),
    debug: (...args) => console.debug('[E1P DEBUG]', ...args), // console.debug might not show in all browser consoles by default
};

export default logger;